export default class IncDecInput {

    init() {
        this.increaseValue();
        this.decreaseValue();
    }

    increaseValue() {
        $('.js-number-increase').on('click', function () {
            let inputWrapper = $(this).closest('.js-input-increment'),
                input = $(this).closest('.js-input-increment').find('.js-input-number'),
                value = parseInt(input.val(), 10);
            value = isNaN(value) ? 1 : value;
            value++;
            input.val(value);
            if (value > 1) {
                inputWrapper.removeClass('disable-decrease');
            }
        })
    }

    decreaseValue() {
        $('.js-number-decrease').on('click', function () {
            let inputWrapper = $(this).closest('.js-input-increment'),
                input = $(this).closest('.js-input-increment').find('.js-input-number'),
                value = parseInt(input.val(), 10);
            value = isNaN(value) ? 2 : value;
            value < 2 ? value = 2 : '';
            value--;
            input.val(value);

            if (value < 2) {
                inputWrapper.addClass('disable-decrease');
            } else {
                inputWrapper.removeClass('disable-decrease');
            }
        })

    }
}


// WEBPACK FOOTER //
// ./static/js/components/IncDecInput.js